import { createStyles, Theme } from '@material-ui/core';

export const styles = ({
  spacing: { unit },
  custom: {
    palette: { colorSupportPowder },
  },
}: Theme) =>
  createStyles({
    text: {
      whiteSpace: 'nowrap',
      marginRight: unit,
    },
    senderAndReceiverDiv: {
      display: 'flex',
      alignItems: 'center',
      flex: 1,
    },
    selectRoot: {
      width: 180,
      maxWidth: 300,
      margin: unit,
      '& .Select-menu-outer': {
        bottom: '56px',
        top: 'initial',
        zIndex: 200,
      },
    },
    selectInput: {
      '& .Select-value': {
        display: 'block !important',
        width: `calc(100% - ${unit}px) !important`,
      },
    },
  });
